import { OEAsset, useClient, useContents } from "@adamlip/okeoke.client"
import { Card, CardBody, CardFooter, cn } from "@nextui-org/react"
import OrderItemModalV3 from "components/Modals/OrderItemModalV3"
import { BasketContext } from "contexts/BasketContext"
import useStorage from "hooks/useStorage"
import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"

export default function ContentBox({ element }) {
  const { contents } = useContents()

  const { getName, languageCode, setSelectedLocation } = useClient()
  const { setSV } = useStorage()
  const { setIsUserSelectedLocation } = useContext(BasketContext)

  const [boxData, setBoxData] = useState(null)
  const [orderItemModalOpen, setOrderItemModalOpen] = useState(false)
  const [selectedItemUUID, setSelectedItemUUID] = useState(null)
  const navigate = useNavigate()

  const handleClick = (item) => {
    if (item?.action === "selectLocation" && item?.params?.locationUUID) {
      setSelectedLocation(item?.params?.locationUUID)
      setIsUserSelectedLocation(true)
      navigate(`/order`)
    }
    if (item?.action === "openItem" && item?.params?.itemUUID) {
      setSelectedItemUUID(item?.params?.itemUUID)
      setOrderItemModalOpen(true)
    }
    if (item?.action === "navigateToCoupons") {
      navigate(`/coupons/all`)
    }
    if (item?.action === "openCateg" && item?.params?.categUUID) {
      navigate(`/order?categoryUUID=${item?.params?.categUUID}`)
      setSV("selectedCategory", item?.params?.categUUID)
    }
    if (item?.action === "createExternalLink" && item?.params?.externalLink) {
      window.open(item?.params.externalLink)
    }
  }

  useEffect(() => {
    let selectedContent = {}
    if (contents != null) {
      // for (let content of Object.values(contents || {})) {
      //   if (content?.uuid === element?.attributes?.selectedContent) {
      //     contentArray.push(content);
      //   }
      // }
      selectedContent = Object.values(contents || {})?.find((content) => {
        return content?.uuid === element?.attributes?.selectedContent
      })
    }
    setBoxData(selectedContent)
  }, [contents, element])
  if (!boxData || boxData?.contentElements?.length === 0) return null
  return (
    <div className="w-[400px] max-w-full p-1 m-auto md:m-0">
      <div className="aspect-ratio">
        <div className="w-full h-full px-3 rounded-[var(--general-border-radius)] ">
          {orderItemModalOpen && selectedItemUUID && (
            <OrderItemModalV3
              isOpen={orderItemModalOpen}
              setIsOpen={setOrderItemModalOpen}
              itemUUID={selectedItemUUID}
            />
          )}
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            //pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            loop={true}
          >
            {boxData?.contentElements
              ?.filter((el) => {
                if (el?.image?.uuid || el?.video?.uuid) {
                  return true
                } else {
                  return false
                }
              })
              ?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="rounded-[var(--general-border-radius)] "
                  >
                    <SwiperSlide
                      key={index}
                      className="rounded-[var(--general-border-radius)] "
                    >
                      <Card
                        className="max-h-[200px] w-full h-[200px] rounded-[var(--general-border-radius)] "
                        classNames={{
                          base: cn("data-[pressed=true]:scale-[0.9]"),
                        }}
                        isPressable
                        onClick={() => {
                          handleClick(item)
                        }}
                      >
                        <CardBody className="p-0 overflow-hidden">
                          {item.image?.uuid != null && item.image?.uuid !== "" && (
                            <div className="w-full h-[200px]">
                              <OEAsset
                                uuid={item.image?.uuid}
                                addClass={"w-full !h-[200px] object-cover"}
                                size="l"
                              />
                            </div>
                          )}
                          {item.video?.uuid != null && item.video?.uuid !== "" && (
                            <div className="w-full h-[200px]">
                              <video
                                className="w-full h-[200px] object-cover"
                                autoPlay
                                loop
                                muted
                              >
                                <source
                                  src={item.video?.originUrl}
                                  type="video/mp4"
                                />
                              </video>
                            </div>
                          )}
                        </CardBody>
                        {((item?.title?.[languageCode] != null &&
                          item?.title?.[languageCode].length > 0) ||
                          (item?.text?.[languageCode] != null &&
                            item?.text?.[languageCode].length > 0)) && (
                            <CardFooter className="absolute bg-background/40 bottom-0 overflow-hidden z-10 border-t-1 border-background dark:border-default-100">
                              <div className="flex flex-grow gap-2 items-center max-w-[80%] ">
                                <div className="flex flex-col w-full">
                                  <p className="text-tiny font-bold text-left ">
                                    {getName(item?.title)}
                                  </p>
                                  <p className="text-tiny font-medium text-left opacity-60 grow truncate">
                                    {getName(item?.text)}
                                  </p>
                                </div>
                              </div>
                              {/* {(item?.params?.itemUUID || item?.params?.categUUID) && (
                      <Button onPress={() => handleClick(item)} color='primary' radius='full' size='sm' className='w-auto'>
                        {item?.params?.itemUUID ? getValue('app_v2_contentBox_openItem') : item?.params?.categUUID ? getValue('app_v2_contentBox_openCategory') : ''}
                      </Button>
                    )} */}
                            </CardFooter>
                          )}
                      </Card>
                    </SwiperSlide>
                  </div>
                )
              })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}
